__turbopack_context__.v({
  "className": "source_sans_3_6dd5f13c-module__iIMAtW__className",
  "variable": "source_sans_3_6dd5f13c-module__iIMAtW__variable",
});
